import { PassKey } from './types'

export { GradeKey } from '@/externals/gyym/user/grades'

export const passLabels = {
  [PassKey.GREENY]: 'GREENY PASS',
  [PassKey.BEGINNER]: 'BEGINNER PASS',
  [PassKey.LIGHT]: 'LIGHT PASS',
  [PassKey.STANDARD]: 'STANDARD PASS',
  [PassKey.SILVER]: 'SILVER PASS',
  [PassKey.GOLD]: 'GOLD PASS',
  [PassKey.PREMIUM]: 'PREMIUM PASS',
  [PassKey.VIP]: 'VIP PASS',
  [PassKey.GYYM_MASTER]: 'GYYM MASTER',
}

export const passDescriptions = {
  [PassKey.GREENY]:
    'BEGINNER PASS保有中に、前月の利用が0件の場合にGREENY PASSにランクダウンされます。',
  [PassKey.BEGINNER]:
    'GYYM PASSスタート時のランクになります。<br />月の利用回数が2回以上になるとLIGHT PASSへランクアップします。利用回数が0回になるとGREENY PASSヘランクダウンしますのでご注意ください。',
  [PassKey.LIGHT]:
    '月の利用回数が3回以上になるとSTANDARD PASSへランクアップします。利用回数が1回以下になるとBEGINNER PASSヘランクダウンしますのでご注意ください。',
  [PassKey.STANDARD]:
    '月の利用回数が4回以上になるとSILVER PASSへランクアップします。利用回数が1回以下になるとLIGHT PASSヘランクダウンしますのでご注意ください。',
  [PassKey.SILVER]:
    '月の利用回数が5回以上になるとGOLD PASSへランクアップします。利用回数が3回以下になるとSTANDARD PASSヘランクダウンしますのでご注意ください。',
  [PassKey.GOLD]:
    '月の利用回数が6回以上になるとPREMIUM PASSへランクアップします。利用回数が3回以下になるとSILVER PASSヘランクダウンしますのでご注意ください。',
  [PassKey.PREMIUM]:
    '月の利用回数が8回以上になるとVIP PASSへランクアップします。利用回数が5回以下になるとGOLD PASSヘランクダウンしますのでご注意ください。',
  [PassKey.VIP]:
    '月の利用回数が10回以上になるとGYYM MASTERへランクアップします。利用回数が5回以下になるとPREMIUM PASSヘランクダウンしますのでご注意ください。',
  [PassKey.GYYM_MASTER]:
    'GYYM PASS最高ランクになります。<br />月の利用回数が8回以下になるとVIP PASSヘランクダウンしますのでご注意ください。',
}

export const passImages = {
  [PassKey.GREENY]: 'assets/images/pass/pass_greeny.png',
  [PassKey.BEGINNER]: 'assets/images/pass/pass_beginner.png',
  [PassKey.LIGHT]: 'assets/images/pass/pass_light.png',
  [PassKey.STANDARD]: 'assets/images/pass/pass_standard.png',
  [PassKey.SILVER]: 'assets/images/pass/pass_silver.png',
  [PassKey.GOLD]: 'assets/images/pass/pass_gold.png',
  [PassKey.PREMIUM]: 'assets/images/pass/pass_premium.png',
  [PassKey.VIP]: 'assets/images/pass/pass_vip.png',
  [PassKey.GYYM_MASTER]: 'assets/images/pass/pass_gyym_master.png',
}

export const passCircleImages = {
  [PassKey.GREENY]: 'assets/images/pass/pass_greeny_circle.png',
  [PassKey.BEGINNER]: 'assets/images/pass/pass_beginner_circle.png',
  [PassKey.LIGHT]: 'assets/images/pass/pass_light_circle.png',
  [PassKey.STANDARD]: 'assets/images/pass/pass_standard_circle.png',
  [PassKey.SILVER]: 'assets/images/pass/pass_silver_circle.png',
  [PassKey.GOLD]: 'assets/images/pass/pass_gold_circle.png',
  [PassKey.PREMIUM]: 'assets/images/pass/pass_premium_circle.png',
  [PassKey.VIP]: 'assets/images/pass/pass_vip_circle.png',
  [PassKey.GYYM_MASTER]: 'assets/images/pass/pass_gyym_master_circle.png',
}

export const passCircleAltImages = {
  [PassKey.GREENY]: 'assets/images/pass/pass_greeny_circle_alt.png',
  [PassKey.BEGINNER]: 'assets/images/pass/pass_beginner_circle_alt.png',
  [PassKey.LIGHT]: 'assets/images/pass/pass_light_circle_alt.png',
  [PassKey.STANDARD]: 'assets/images/pass/pass_standard_circle_alt.png',
  [PassKey.SILVER]: 'assets/images/pass/pass_silver_circle_alt.png',
  [PassKey.GOLD]: 'assets/images/pass/pass_gold_circle_alt.png',
  [PassKey.PREMIUM]: 'assets/images/pass/pass_premium_circle_alt.png',
  [PassKey.VIP]: 'assets/images/pass/pass_vip_circle_alt.png',
  [PassKey.GYYM_MASTER]: 'assets/images/pass/pass_gyym_master_circle_alt.png',
}
